import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { NavLink as RouterLink, useLocation } from "react-router-dom";
import { Button, Collapse, ListItem, Typography } from "@mui/material";
import "./index.scss";

const SidebarItem = ({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  ...rest
}) => {
  const [open, setOpen] = useState(openProp);
  const location = useLocation();
  const isActive = location.pathname === href;

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const buttonStyles = {
    width: "92%",
    letterSpacing: 0,
    fontWeight: "400",
    marginBottom: "8px",
    color: "primary.main",
    textTransform: "none",
    justifyContent: "flex-start",
    "&:hover": {
      color: "#fff",
      borderRadius: "10px",
      backgroundColor: "#6959cc",
    },
  };

  const buttonLeafStyles = {
    width: "92%",
    letterSpacing: 0,
    fontSize: "14px",
    fontWeight: "400",
    marginBottom: "5px",
    padding: "13px 20px",
    borderRadius: "10px",
    textTransform: "none",
    justifyContent: "center",
    color: isActive ? "#ffffff" : "#121010",
    backgroundColor: isActive ? "var(--color-primary)" : "transparent",
    "&:hover": {
      borderRadius: "10px",
      color: "#fff !important",
      backgroundColor: "var(--color-primary)",
      ".nav-item-icon": {
        color: "#fff",
      },
    },
    "&.depth-0": {
      fontSize: "13px",
      fontWeight: "400",
      lineHeight: "17px",
      fontFamily: "Sora, sans-serif",
    },
  };

  const iconStyles = {
    marginLeft: 1,
    marginRight: 2,
    display: "flex",
    alignItems: "center",
    color: isActive ? "#ffffff" : "#121010",
    "&:hover": { color: "#fff" },
  };

  const titleStyles = {
    fontSize: 14,
    fontWeight: 600,
    color: "inherit",
    marginRight: "auto",
  };

  if (children) {
    return (
      <ListItem className={className} disableGutters key={title} {...rest}>
        <Button sx={buttonStyles} onClick={handleToggle}>
          {Icon && <Icon sx={iconStyles} />}
          <Typography sx={titleStyles}>{title}</Typography>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem
      className={`${className} depth-${depth}`}
      disableGutters
      key={title}
      {...rest}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Button
        to={href}
        sx={buttonLeafStyles}
        component={RouterLink}
        style={{ marginTop: -10 }}
      >
        {Icon && <Icon sx={{ ...iconStyles }} className="nav-item-icon" />}
        <Typography sx={titleStyles}>{title}</Typography>
        {Info && <Info />}
      </Button>
    </ListItem>
  );
};

export default SidebarItem;
